import { Observable, of } from 'rxjs'
import { filter, map, switchMap, take } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'

import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'

import { organizationSelectors } from '../organization.selectors'
import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request'
import { UntilDestroy } from '@ngneat/until-destroy'
import { settingSelectors } from 'src/app/core/settings/settings.selectors'
import { Activity } from '../../activity/activity'
import { activitySelectors } from '../../activity/activity.selectors'
import { activityActions } from '../../activity/activity.actions'
import { OrganizationService } from '../organization.service'
import { ActivatedRoute } from '@angular/router'

@UntilDestroy()
@Component({
  selector: 'organization-activities-tab',
  templateUrl: './show.component.html'
})
export class OrganizationActivitiesTabComponent implements OnInit {
  public organizationId$: Observable<number>
  public activities$: Observable<Activity[]>
  public selectedLanguage$: Observable<string>
  public filterTerm: string = ''

  constructor(
    private store: Store<AppState>,
    private organizationService: OrganizationService,
    private activeRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.selectedLanguage$ = this.store.select(
      settingSelectors.selectById,
      'language'
    )

    if (this.organizationService.showModal) {
      this.activeRoute.params.pipe(take(1)).subscribe((params) => {
        if (params.hasOwnProperty('organizationId')) {
          this.organizationId$ = of(Number(params['organizationId']))
        }
      })
    } else {
      this.organizationId$ = this.store
        .select(organizationSelectors.selectIdRouteParam)
        .pipe(filter((id) => Boolean(id)))
    }

    this.organizationId$.pipe(take(1)).subscribe((organizationId) => {
      this.store.dispatch(
        activityActions.fetchMany({
          params: RequestQueryBuilder.create({
            join: [{ field: 'organization' }, { field: 'member' }],
            search: { organizationId }
          })
        })
      )
    })

    this.activities$ = this.organizationId$.pipe(
      take(1),
      switchMap((organizationId) =>
        this.store.select(activitySelectors.selectByFilter, {
          field: 'organizationId',
          value: organizationId
        })
      ),
      map((activities) => activities.sort((a, b) => (a.id > b.id ? -1 : 1)))
    )
  }

  public onClickRow(activity: Activity): void {}
}
